import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import { sortByAvailableAndFloor } from 'lib/utils';

import {
	Table,
	Row,
	Heading,
	Cell,
} from 'lib/table';

const Container = styled.div`
	width: 50vw;
	max-width: 900px;

	@media (max-width: 1200px) {
		margin: 40px 0 0 0;
		width: 100%;
	}
`;

const SpaceTable = styled(Table)`
	flex-direction: row;
	overflow-y: auto;
`;

const SpaceList = ({ spaces, t, lng }) => {

	console.log(spaces);
	return [...spaces].sort(sortByAvailableAndFloor).map(space => {
		let freeText = space.isFree ? t('building/spaces/Yes') : t('building/spaces/No');

		const freeFrom = new Date(space.free_from);
		const now = new Date();

		if (
			!isNaN(freeFrom.getFullYear()) &&
			freeFrom.getFullYear() > 2000 &&
			freeFrom.getTime() > now.getTime()
		) {
			let dateString = '';
			const year = freeFrom.getFullYear();

			dateString = `${freeFrom.getDate()}.${freeFrom.getMonth()}.`;

			if (year !== now.getFullYear()) {
				dateString += year;
			}

			freeText += ` (${dateString})`;
		}

		const type = t('space-type/' + space.type);
		const spaceName = (space.i18n[lng].name || type);
		const spaceNameHtml = space.default_brochure_pdf ? <a href={space.default_brochure_pdf} target="_blank">{spaceName}</a> : spaceName;

		return (
			<Row key={space.slug}>
				<Cell style={{ width: '10%' }}>{space.floor}</Cell>
				<Cell style={{ width: '40%' }}>{spaceNameHtml}</Cell>
				<Cell style={{ width: '15%' }}>{freeText}</Cell>
				<Cell style={{ width: '15%' }}>{space.area} m²</Cell>
				<Cell style={{ width: '20%' }} end="true">{space.indicative_price_per_sqm ? space.indicative_price_per_sqm + ' €' : ''}</Cell>
			</Row>
		)
	});

};

SpaceList.propTypes = {
	spaces: PropTypes.array,
}

const Spaces = ({ t, lng, spaces }) => (
	<Container>
		<SpaceTable >
			<Row>
				<Heading style={{ width: '10%' }}>{t('building/spaces/Floor')}</Heading>
				<Heading style={{ width: '40%' }}>{t('building/spaces/Space')}</Heading>
				<Heading style={{ width: '15%' }}>{t('building/spaces/Available')}</Heading>
				<Heading style={{ width: '15%' }}>{t('building/spaces/Area')}</Heading>
				<Heading style={{ width: '20%' }} end="true">{t('building/spaces/indicative price')}</Heading>
			</Row>
		</SpaceTable>
		<SpaceTable style={{ maxHeight: '300px' }}>
			<SpaceList spaces={spaces} t={t} lng={lng} />
		</SpaceTable>
	</Container>
);

Spaces.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	spaces: PropTypes.array,
}

export default translate('translations')(Spaces);
